import { FC } from 'react';
import { Council, Society } from 'types';
import CouncilsCard from './CouncilsCard';

type CouncilsListBodyProps = {
  councils: Council[];
  society: Society;
};

const CouncilsListBody: FC<CouncilsListBodyProps> = ({ councils, society }) => (
  <div className="nk-content-wrap">
    {councils?.map((council) => (
      <CouncilsCard key={council._id} council={council} society={society} />
    ))}
  </div>
);

export default CouncilsListBody;
